import React, {Component} from 'react';
import {SketchPicker} from 'react-color';


export default class ColorSelectField extends Component {
    onChange(color) {
        const rgb = color.rgb;
        this.props.onChange(`${rgb.r},${rgb.g},${rgb.b},${rgb.a}`);
    }

    parseString(string) {
        if (!string) {
            return;
        }
        const colors = string.split(',');
        return {r: colors[0], g: colors[1], b: colors[2], a: colors[3]};
    }

    render() {
        return (<SketchPicker
            color={this.parseString(this.props.value)}
            onChangeComplete={this.onChange.bind(this)}/>)
    }
}



// WEBPACK FOOTER //
// ./src/js/components/form/color-select-field.js